module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6n3UO"))).then(() => parcelRequire('1iHdE'));